// src/components/Arguente/ArguenteList.jsx
import React, { useEffect, useState } from 'react';
import { listarArguentes } from '../../services/arguenteService';

const ArguenteList = () => {
    const [arguentes, setArguentes] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await listarArguentes();
            setArguentes(response.data);
        };
        fetchData();
    }, []);

    return (
        <div>
            <h2>Lista de Arguentes</h2>
            <ul>
                {arguentes.map((arguente) => (
                    <li key={arguente.id}>{arguente.usuario.nome} - {arguente.areasInteresse.join(', ')}</li>
                ))}
            </ul>
        </div>
    );
};

export default ArguenteList;